import { render } from "./SubscribeHeader.vue?vue&type=template&id=2ba6096f&scoped=true"
import script from "./SubscribeHeader.vue?vue&type=script&lang=js"
export * from "./SubscribeHeader.vue?vue&type=script&lang=js"

import "./SubscribeHeader.vue?vue&type=style&index=0&id=2ba6096f&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ba6096f"]])

export default __exports__